var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10838_3259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 13.2539V19.4503H24.939C24.5609 21.443 23.4262 23.1303 21.7244 24.2649L26.9171 28.294C29.9426 25.5014 31.688 21.3995 31.688 16.5268C31.688 15.3923 31.5862 14.3013 31.3971 13.2541L16.3281 13.2539Z",
    fill: "#777E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36355 19.2109L6.1924 20.1074L2.04688 23.3365C4.6796 28.5582 10.0756 32.1656 16.3301 32.1656C20.6499 32.1656 24.2717 30.7401 26.919 28.2965L21.7263 24.2674C20.3009 25.2274 18.4827 25.8093 16.3301 25.8093C12.1701 25.8093 8.63564 23.002 7.37009 19.2202L7.36355 19.2109Z",
    fill: "#B1B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04436 8.99219C0.953514 11.1448 0.328125 13.574 0.328125 16.163C0.328125 18.752 0.953514 21.1812 2.04436 23.3338C2.04436 23.3483 7.36809 19.2029 7.36809 19.2029C7.04809 18.2429 6.85895 17.2248 6.85895 16.1628C6.85895 15.1009 7.04809 14.0828 7.36809 13.1228L2.04436 8.99219Z",
    fill: "#D6D8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3304 6.53497C18.6868 6.53497 20.7813 7.34949 22.454 8.92042L27.0358 4.33866C24.2576 1.74962 20.6504 0.164062 16.3304 0.164062C10.0759 0.164062 4.6796 3.75678 2.04688 8.99316L7.37044 13.1241C8.63582 9.34222 12.1704 6.53497 16.3304 6.53497Z",
    fill: "#E6E8EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10838_3259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.332031 0.167969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.aeffb8bc97c9c2b8c7df59ab0e9fe923.svg";
export { ForwardRef as ReactComponent };